import { render, staticRenderFns } from "./IconPerson.vue?vue&type=template&id=77ed1b9b&"
import script from "./IconPerson.vue?vue&type=script&lang=js&"
export * from "./IconPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ed1b9b')) {
      api.createRecord('77ed1b9b', component.options)
    } else {
      api.reload('77ed1b9b', component.options)
    }
    module.hot.accept("./IconPerson.vue?vue&type=template&id=77ed1b9b&", function () {
      api.rerender('77ed1b9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPerson.vue"
export default component.exports